exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width{width:100%}.full-height{height:100%}.froala-height{min-height:70vh;padding-left:46px;padding-right:46px;overflow:auto;margin-bottom:35px}.disable-button button{pointer-events:none}.fr-view h1,.fr-view h2,.fr-view h3,.fr-view h4,.fr-view h5,.fr-view h6{font-family:inherit}.fr-view h1{font-size:48px}.fr-view h2{font-size:36px}.fr-view h3{font-size:24px}.fr-view h4{font-size:18px}.fr-view .jw-logo{width:30%!important}.fr-view .message{margin-top:50px}.fr-view .compliance-text{font-style:italic;color:#707070;font-size:small;padding-left:54px!important}", ""]);

// exports
